<template>
<div class="userArticle">
  <div>
    <div><img src="@/assets/my_fav.png" alt=""></div>
    <span>我的喜欢</span>
  </div>
  <div>
    <div><img src="@/assets/my_his.png" alt=""></div>
    <span>我的历史</span>
  </div>
  <div>
    <div><img src="@/assets/my_post.png" alt=""></div>
    <span>创作中心</span>
  </div>
  <div>
    <div><img src="@/assets/my_movie.png" alt=""></div>
    <span>已购影片</span>
  </div>
</div>
</template>

<script>
export default {
  name: "userArticle"
}
</script>

<style scoped lang="scss">
.userArticle{
  display: flex;
  background-color: white;
  padding: 0 2.778vw;
  div{
    display: flex;
    flex-direction: column;
    width: 25%;
    margin: 2vw;
    justify-content: center;
    align-items: center;
    span{
      font-size: 3vw;
      margin-bottom: 2vw;
    }
    div{
      img{
        width: 24px;
      }
    }
  }
}
</style>
